import React from 'react'
import PropTypes from 'prop-types'

const JourneyItem = ({ journey: { title, description } }) => {

    const pureTitle = title.toLowerCase().trim();

    return (
        <div>
        { pureTitle === 'javascript' && <i className="fab fa-js fa-4x my-2 process-icon"></i> }
        { pureTitle === 'html5-css3' && <i className="fab fa-css3 fa-4x my-2 process-icon"></i> }
        { pureTitle === 'react.js' && <i className="fab fa-react fa-4x my-2 process-icon"></i> }
        { pureTitle === 'node.js' && <i className="fab fa-node fa-4x my-2 process-icon"></i> }
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    )
}

JourneyItem.propTypes = {
  journey: PropTypes.object.isRequired,
}

export default JourneyItem
